import { mapState } from "vuex";
import Store from "../store";
import { PermissionsConstants } from "@/permissions";

export default {
    methods: {
        async canAccessRoute(baseRoute, itemId, action) {
            if (!Store.state.user.permissions || !Store.state.user.role) {
                try {
                    await Store.dispatch("getUserData");
                } catch (error) {
                    console.error("Error fetching user data:", error);
                    return false;
                }
            }

            if (Store.state.user.role === PermissionsConstants.ROLE_SUPERADMIN) {
                return true;
            }

            const userPermissions = Store.state.user.permissions;

            const formattedBaseRoute = this.formatBaseRoute(baseRoute);

            if (
                userPermissions &&
                userPermissions.hasOwnProperty(formattedBaseRoute) &&
                userPermissions[formattedBaseRoute].includes(PermissionsConstants.LIST)
            ) {
                if (itemId && itemId !== "new" && action === "edit") {
                    return userPermissions[formattedBaseRoute].includes(PermissionsConstants.EDIT);
                }

                if (itemId && itemId === "new" && action === "edit") {
                    return userPermissions[formattedBaseRoute].includes(PermissionsConstants.CREATE);
                }

                if (itemId && itemId === "group") {
                    return (
                        Store.state.user.work_roles &&
                        Store.state.user.work_roles.includes(PermissionsConstants.ROLE_HEAD_OF_SHIFT)
                    );
                }
                if (itemId) {
                    return userPermissions[formattedBaseRoute].includes(PermissionsConstants.VIEW);
                }

                return true;
            }

            return false;
        },
        formatBaseRoute(baseRoute) {
            let formattedBaseRoute = baseRoute.replaceAll("-", "_");

            if (formattedBaseRoute === "shops") {
                formattedBaseRoute = "shops_map";
            } else if (formattedBaseRoute === "shops_admin") {
                formattedBaseRoute = "shop";
            } else if (formattedBaseRoute === "export_sale_invoice") {
                formattedBaseRoute = "export";
            } else if (formattedBaseRoute === "sales_invoice") {
                formattedBaseRoute = "invoice";
            } else if (formattedBaseRoute === "rule") {
                formattedBaseRoute = "rules";
            } else if (formattedBaseRoute === "analysis_view") {
                formattedBaseRoute = "analysis";
            } else if (formattedBaseRoute === "production_analysis_view") {
                formattedBaseRoute = "production_analysis";
            } else if (formattedBaseRoute === "ext_product_price") {
                formattedBaseRoute = "price_monitoring";
            }
            return formattedBaseRoute;
        }
    }
};
